import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-161e8440"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { withDefaults, CSSProperties, ref, Ref, watch } from 'vue'

interface RadioOptionItem {
  label: string
  value: string | number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [props: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CommmonRadioGroup',
  props: {
    value: null,
    radioItemStyle: null,
    options: { default: () => [] },
    class: null
  },
  emits: ['update:value', 'change'],
  setup(__props: any, { emit: emits }) {

const props = __props as { value?: string | number, radioItemStyle?: CSSProperties, options: Array<RadioOptionItem>, class?: string };




watch(
  () => props.value,
  () => {
    const current = props.options.filter((item) => item.value === props.value)[0]
    radioValue.value = props.value
    if (current) {
      currentItem.value = current
    }
  }
)

const radioValue: Ref<number | string> = ref(props.value || '')
const currentItem: Ref<null | RadioOptionItem> = ref(null)
function getGroupWrapCalss() {
  return `row-wrap ${props.class || ''}`
}
function clickHandle(item: RadioOptionItem) {
  currentItem.value = item
  radioValue.value = item.value
  emits('update:value', item.value)
  emits('change', item.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radio-group-wrap", getGroupWrapCalss])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(radioValue.value === item.value ? 'active' : ''),
        key: item.value,
        style: _normalizeStyle(props.radioItemStyle),
        onClick: ($event: any) => (clickHandle(item))
      }, [
        _renderSlot(_ctx.$slots, "radioContent", { data: item }, () => [
          _createTextVNode(_toDisplayString(item.label), 1)
        ])
      ], 14, _hoisted_1))
    }), 128))
  ]))
}
}

})